export default __webpack_public_path__ + "static/media/i-exterior-connect.46289a78.svg";